<template>
  <div class="grid" id="biz">
    <div
      v-for="c in cards"
      :key="c.title"
      class="card"
      @click="$router.push({ path: '/productService', query: { key: 'brand' } })"
    >
      <div class="card-img">
        <img :src="c.img" :alt="c.title" />
        <span class="card-chip">{{ c.en }}</span>
      </div>
      <div class="card-content">
        <div class="title">{{ c.title }}</div>
        <div class="desc">{{ c.desc }}</div>
        <div class="more">
          了解详情
          <span class="more-arrow" aria-hidden="true">→</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 四大核心品类（贴合公司实际业务）
const cards = [
  {
    title: "家用电器",
    en: "HOME APPLIANCE",
    desc: "小家电制造与加工，成熟的注塑、装配工艺，支持 OEM / ODM 多元化定制。",
    img: require("../static/1.webp"),
  },
  {
    title: "照明灯具",
    en: "LIGHTING",
    desc: "灯具产品的制造与配套，包含工业定位灯等特种照明，满足多样应用场景。",
    img: require("../static/2.webp"),
  },
  {
    title: "塑料制品",
    en: "PLASTIC PRODUCTS",
    desc: "各类塑料制品的注塑成型与加工，规格灵活，交期稳定，品质全程可控。",
    img: require("../static/6.webp"),
  },
  {
    title: "五金件",
    en: "HARDWARE",
    desc: "精密五金件的加工制造，适配家电、灯具及多种工业零部件的配套需求。",
    img: require("../static/4.webp"),
  },
];
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.card {
  background: #fff;
  border: 1px solid #eef1f5;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;
}

.card:hover {
  transform: translateY(-6px);
  border-color: #d5e6f8;
  box-shadow: 0 20px 44px rgba(10, 79, 151, 0.12);
}

.card-img {
  position: relative;
  height: 170px;
  overflow: hidden;
}

.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.45s ease;
}

.card:hover .card-img img {
  transform: scale(1.08);
}

.card-chip {
  position: absolute;
  left: 14px;
  bottom: 12px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(10, 79, 151, 0.92);
  color: #fff;
  font-size: 11px;
  letter-spacing: 1px;
  font-weight: 700;
}

.card-content {
  padding: 18px 18px 20px;
}

.title {
  font-size: 19px;
  font-weight: 800;
  color: #102a43;
}

.desc {
  margin-top: 10px;
  font-size: 13.5px;
  line-height: 1.75;
  color: #5b6b7e;
  min-height: 68px;
}

.more {
  margin-top: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 700;
  color: #0a4f97;
}

.more-arrow {
  transition: transform 0.25s ease;
}

.card:hover .more-arrow {
  transform: translateX(4px);
}

@media (max-width: 1080px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
